import React from 'react';
import styled from 'styled-components';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux'
import H1 from "../../Components/H1";
import {ToolbarWithLogo} from '../../Components/Toolbar';
import ContainerPage, {Routes} from "../ContainerPage";
import {setEmployee} from '../Welcome/Actions';
import {BottomWrapper, SelectViewWrapper, TopWrapper} from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import Select from "../../Components/Select";
import ProgressTracker from "../../Components/ProgressTracker";
import Toast from "../../Components/Toast";
import {getSafely, valueOrDefault} from "@tomeravni/easybizy-js-common/common";
import {PROGRESS_KEY} from "../../Common/constants";

const HH1 = styled(H1)`
    z-index: 1;
    text-align: center;
    width: 100%;
`;

class PickEmployee extends ContainerPage {
    state = {};

    constructor(props) {
        super(props);

        this.nextRoute = Routes.pickTime;
    }

    pickEmployee(employee) {
        this.props.setEmployee(employee);
        this.next();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.config && !nextProps.services) {
            this.goBack();
        }
    }

    employeeNameProp(employee) {
        return `${employee.FirstName}${employee.LastName ? ' ' + employee.LastName : ''}`
    }

    render() {
        const ltr = !this.props.intl.locale.includes('he');
        const currentProgressIndex = valueOrDefault(this.props.progress, []).findIndex((p) => p.label === PROGRESS_KEY.EMPLOYEE) || 0;
        const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

        return (
            <div className="transition-item detail-page detail-page__pick-employee">
                <SelectViewWrapper padding={true} bottomPadding={false} loading={!this.props.config} ltr={ltr}>
                    <ToolbarWithLogo
                        imageUri={toolbarLogo || ""} ltr={ltr}
                        rootUri={this.getRoutePrefix()}>
                        <ProgressTracker progress={this.props.progress} current={currentProgressIndex}
                                         visible={true}/>

                    </ToolbarWithLogo>

                    <TopWrapper justify="start" align="start" preventFlex={true}>
                        <HH1><FormattedMessage id="schedule.pickAnEmployee"/></HH1>
                        {this.state.didMount &&
                            <Select
                                showImage={this.props.showEmployeesAvatar}
                                ltr={ltr}
                                selected={this.props.employee}
                                onClick={(employee) => this.pickEmployee(employee)}
                                items={this.props.employees} keyProp="EmployeeId"
                                nameProp={this.employeeNameProp}/>}

                    </TopWrapper>
                    <BottomWrapper empty={true}>
                        <PoweredBy/>
                    </BottomWrapper>
                </SelectViewWrapper>
                <Toast ref={(toast) => this.toast = toast}/>
            </div>
        )
    }
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
    return {
        loading: state.schedule.fetchingConfig || state.schedule.fetchingServices,
        config: state.schedule.configWithServices,
        progress: state.schedule.progress,
        services: state.schedule.services,
        employee: state.schedule.employee,
        employees: state.schedule.availableEmployees,
        showEmployeesAvatar: !!getSafely(['ShowEmployeesAvatar'], state.schedule.configWithServices)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setEmployee: (employee) => dispatch(setEmployee(employee))

    }
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PickEmployee));
